import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5586fe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = {
  key: 0,
  class: "content"
}
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "s-row" }
const _hoisted_5 = { class: "s-col s-col-12 main-content" }

import {
  computed,
  ComputedRef,
  ref,
} from 'vue';
import { useRoute } from 'vue-router';

import { SSnackbarContainer } from '@simmons/components';

import { Views } from '@/router/enums';
import { sidebarWidths } from '@/config/constants';
import AppLayout from '@/layout/AppLayout.vue';
import AppSidebar from '@/layout/AppSidebar.vue';
import BrandingHeader from '@/layout/components/BrandingHeader.vue';
import { useStore } from 'vuex';
import { AppGetters } from './store/modules/app/getters';
import { Snackbar } from './store/modules/app/snackbar/snackbar.types';
import { AppMutations } from './store/modules/app/mutations';
import { RecommendedBrowserBanner } from '@/components';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "2ed847e2": (sidebarWidth.value)
}))

const isSidebarHovering = ref(false);
const sidebarWidth = ref(sidebarWidths.opened);
const route = useRoute();
const store = useStore();
const snackbars: ComputedRef<Snackbar[]> = computed(() => (
  store.getters[AppGetters.APP__SNACKBAR]
));

const isAuthPage = computed(() => {
  const { name: routeName } = route;

  return (!routeName || (routeName && routeName === Views.AUTHENTICATION));
});

const onSidebarOpen = (opened: boolean | undefined): void => {
  sidebarWidth.value = opened ? sidebarWidths.opened : sidebarWidths.closed;
};

const toggleWidth = (): void => {
  if (sidebarWidth.value !== sidebarWidths.closed) {
    isSidebarHovering.value = !isSidebarHovering.value;
    sidebarWidth.value = isSidebarHovering.value ? sidebarWidths.hovered : sidebarWidths.opened;
  }
};
const removeSnackbar = (id: string) => {
  store.commit(AppMutations.APP__REMOVE_SNACKBAR, id);
};


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(RecommendedBrowserBanner)),
    (!_unref(isAuthPage))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppLayout, null, {
            appSidebar: _withCtx(() => [
              _createVNode(AppSidebar, {
                class: "menu",
                "sidebar-width": sidebarWidth.value,
                onMouseenter: toggleWidth,
                onMouseleave: toggleWidth
              }, null, 8, ["sidebar-width"])
            ]),
            appMainContent: _withCtx(() => [
              _createElementVNode("main", _hoisted_3, [
                _createVNode(BrandingHeader, { onOnSidebarOpen: onSidebarOpen }),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(SSnackbarContainer), {
                      "snackbars-data-arr": _unref(snackbars),
                      position: 'top',
                      width: 20,
                      onPopFromQueue: _cache[0] || (_cache[0] = ($event: any) => (removeSnackbar($event)))
                    }, null, 8, ["snackbars-data-arr"]),
                    _createVNode(_component_router_view)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ]))
}
}

})